module.exports = "<svg preserveAspectRatio=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 583 95\">\n  <polygon points=\"583,42 583,95 0,95\" />\n  <polygon points=\"0,0 0,95 583,42 583,95\" opacity=\".4\" />\n</svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/shapes/slack.svg
// module id = 2830
// module chunks = 0